<template>
  <section v-if="$route.params.mesg === 'Member paper access denied'">
    <div style="text-align: left; padding: 150px 20px; max-width: 400px; margin: auto">
      <p style="border-bottom: 1px solid #ccc; padding: 10px"><img src="/logo.png" height="30" /></p>
      <div style="padding: 0px 20px">금일 주식신문 열람 횟수가 초과되었습니다.<br />고객센터에 문의하세요.<br /><br />(인포스탁 고객센터 : 1522-1730)</div>
    </div>
  </section>
  <section v-else>
    <h2>Server Error</h2>
    <div>{{ $route.params.mesg }}</div>
    <!-- 오류메세지 주석 -->
    <!-- <section class="out">
        <h2>Error</h2>
        <div class="in">
            <h3><font-awesome-icon icon="fa-solid fa-triangle-exclamation" /></h3>
            <span v-html="$route.params.mesg"/>
        </div> -->
  </section>
</template>

<script>
export default {
  name: "ErrorPage",
};
</script>

<style>
.out {
  width: 100%;
  text-align: center;
}
.in {
  display: inline-block;
}
</style>
